import { Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { DeviatedTableSection as DeviatedTableSectionModel } from './deviatedTable'
import { TableSectionTable } from './TableSectionTable'

type Props = {
  deviatedTableSection: DeviatedTableSectionModel
  goPreviewPhoto: (imageUrls: string[], selectedImageIndex: number) => void
}

export const DeviatedTableSection: FC<Props> = ({
  deviatedTableSection,
  goPreviewPhoto,
}) => {
  const { sectionNode, view } = deviatedTableSection
  return (
    <Stack sx={{ mb: 2, rowGap: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        {sectionNode.section?.name}
      </Typography>
      <TableSectionTable view={view} goPreviewPhoto={goPreviewPhoto} />
    </Stack>
  )
}
